// removed by extract-text-webpack-plugin
module.exports = {"task":"_2N1xVkL8j-Fr-ROX3UzTW7","listArticle":"GKdEKblnVK6qwE6ENFNhL","listStock":"_3qYyekUtKXmw2Xpc10Z-GA","green":"Hx8RQvkcTSdsiSAFYMvxX","red":"_3ZmaYPJdYUcexI8R8wOLp","yellow":"C_a_jHML_F6AmbxgnG-Ps","resolution":"_1REHf6sKtl79HKOH8DQoEF","date":"_3Y8ta9Ju6VImsHeJDOwXav","comment":"_3Ddnzt3ojgTyNAAcRl9-Yc","removed":"_3F1mgVIO5OQXflpFyI1L68"};


//////////////////
// WEBPACK FOOTER
// ./app/dialogs/Task/style.scss
// module id = 1059
// module chunks = 0